export default __webpack_public_path__ + "static/media/background.e6925fd0.png";